import * as React from 'react';
import { useSelector } from 'react-redux';

import { GenplanContainer } from '../../containers/GenplanContainer';
import { offerDataSelector, selectIsOfferPageRedesign } from '../../selectors';
import { KpInfo } from './KpInfo';

export const KpInfoContainer = () => {
  const { kp, offer, agent } = useSelector(offerDataSelector);
  const isRedesignPage = useSelector(selectIsOfferPageRedesign);

  return <KpInfo kp={kp} offer={offer} agent={agent} genplan={<GenplanContainer />} withBorder={!isRedesignPage} />;
};
